import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { useElementInteracted } from '@repo/platform-analytics/hooks/useElementInteracted';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import type { TooltipActionType } from './types';
export function useTooltipPageAction() {
  const $ = _c(7);
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t0;
  if ($[0] !== skuImpressionId) {
    t0 = {
      actionName: "rating_link_tooltip",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const firePageAction = usePageAction(t0);
  let t1;
  if ($[2] !== skuImpressionId) {
    t1 = {
      entityName: "rating_link_tooltip",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[2] = skuImpressionId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fireElementInteracted = useElementInteracted(t1);
  let t2;
  if ($[4] !== fireElementInteracted || $[5] !== firePageAction) {
    const fireTooltipPageAction = (actionType, actionSection) => {
      firePageAction({
        action_type: actionType,
        action_section: actionSection
      });
      fireElementInteracted({
        interaction_type: actionType,
        section_name: actionSection
      });
    };
    t2 = (actionType_0, actionSection_0) => {
      fireTooltipPageAction(actionType_0, actionSection_0);
    };
    $[4] = fireElementInteracted;
    $[5] = firePageAction;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleTooltipClickPageAction = t2;
  return handleTooltipClickPageAction;
}
export function useTooltipPageActionWithoutSkuViewed() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      actionName: "rating_link_tooltip"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const firePageAction = usePageAction(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      entityName: "rating_link_tooltip"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fireElementInteracted = useElementInteracted(t1);
  let t2;
  if ($[2] !== fireElementInteracted || $[3] !== firePageAction) {
    const fireTooltipPageAction = (actionType, actionSection) => {
      firePageAction({
        action_type: actionType,
        action_section: actionSection
      });
      fireElementInteracted({
        interaction_type: actionType,
        section_name: actionSection
      });
    };
    t2 = (actionType_0, actionSection_0) => {
      fireTooltipPageAction(actionType_0, actionSection_0);
    };
    $[2] = fireElementInteracted;
    $[3] = firePageAction;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleTooltipClickPageAction = t2;
  return handleTooltipClickPageAction;
}